<template>
    <div>
        <v-toolbar flat color="white"><v-spacer></v-spacer><v-text-field label="Search" v-model="search"></v-text-field></v-toolbar>
        <v-data-table :items="groupeddata" :headers="headers" :search="search" :rows-per-page-items="[25, 50, 100, 250]" style="cursor: pointer">
             <template v-slot:items="props">
                          <td class="text-xs-center" @click="viewItem(props.item)">
                              {{props.item.serialNumber}}
                          </td>
                          <td class="text-xs-center" @click="viewItem(props.item)">
                              <v-chip v-if="props.item.data[props.item.data.length-1].status==='DRY' || props.item.data[props.item.data.length-1].status==='OK'" color="light-green" class="white--text">OK</v-chip>
                                <v-chip v-else-if="props.item.data[props.item.data.length-1].status==='Leak Detected'" color="red" class="white--text">{{props.item.data[props.item.data.length-1].status}}</v-chip>
                          </td>
                          <td class="text-xs-center" @click="viewItem(props.item)">
                              {{formatDate(props.item.data[props.item.data.length-1].updatedAt)}}
                          </td>
                          <!-- <td class="text-xs-center" @click="viewItem(props.item)">
                              {{props.item.data[props.item.data.length-1].accountId}}
                          </td> -->
                          <td class="text-xs-center" @click="viewItem(props.item)">
                              {{props.item.data.length}}
                          </td>
             </template>
        </v-data-table>
        <v-dialog v-model="viewItemModal" persistent max-width="1000px">
            <v-card>
                <v-toolbar flat color="primary">
                    <h3 class="title white--text">Overview: {{item.serialNumber}}</h3>
                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="item={}, viewItemModal=false">X</v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :items="item.data" :headers="detailHeaders" :pagination.sync="pagination">
                        <template v-slot:items="props">
                            <td class="text-xs-center" @click="viewItem(props.item)">
                              <v-chip v-if="props.item.status==='DRY' || props.item.status==='OK'" color="light-green" class="white--text">OK</v-chip>
                                <v-chip v-else-if="props.item.status==='Leak Detected'" color="red" class="white--text">{{props.item.status}}</v-chip>
                          </td>
                                <td class="text-xs-center">
                                {{props.item.comment}}
                                </td>
                                <td class="text-xs-center">
                                {{formatDate(props.item.updatedAt)}}
                                </td>
                                <td class="text-xs-center">
                                {{props.item.locationId}}
                                </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>

        </v-dialog>
    </div>
</template>
<script>
import dateformat from "dateformat";
export default {
    props: ['data', 'groupeddata'],
    data(){
        return {
            search: '',
            item: {},
            viewItemModal: false,
            pagination: {
  descending: true,
  sortBy: "updatedAt"
},
            headers: [
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber"
      },
      {
          text: "Status",
          align: "center",
          value: "status"
      },
        {
          text: "Last Updated",
          align: "center",
          value: "updatedAt"
      },
    //   {
    //       text: "Account",
    //       align: "center",
    //       value: "accountId"
    //   },
        {
          text: "Entries",
          align: "center",
          value: "data.length"
      }
      ],
      detailHeaders: [
        {
          text: "Status",
          align: "center",
          value: "status"
      },
      {
          text: "Comment",
          align: "center",
          value: "comment"
      },
        {
          text: "Last Updated",
          align: "center",
          value: "updatedAt"
      },
      {
          text: "Account",
          align: "center",
          value: "locationId"
      }
      ],
        }
    },
    created(){
        
    },
    methods: {
        formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy HH:MM:ss");
      } else {
        null;
      }
    },
    viewItem(item){
        this.item=item
        this.viewItemModal=true
    }
    }
}
</script>